import { render, staticRenderFns } from "./OvertimeWorkTypeForm.vue?vue&type=template&id=22993b95&"
import script from "./OvertimeWorkTypeForm.vue?vue&type=script&lang=js&"
export * from "./OvertimeWorkTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./OvertimeWorkTypeForm.vue?vue&type=style&index=0&id=22993b95&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports